const __DEV__ = false;

var data = { zIndex:{ values:{ drawer:1000,
      header:1010,
      input:1020,
      headerFixed:1030,
      backdrop:1040,
      sidebar:1050,
      modal:1060,
      popover:1070,
      toast:1080,
      tooltip:1090 } } };

var zIndex = data;

export { zIndex as default };
//# sourceMappingURL=zIndex.yaml.js.map
